<ham-modal
    [title]="
        view === 'confirm_disconnect'
            ? ('aumico_partner_connect_disconnect_confirm_title' | i18next)
            : connection.displayName
    "
    [hideFooter]="true"
    [size]="'sm'"
    (cancel)="onClose()"
>
    <div class="connect-modal-body">
        <!-- ─────────── Detail ─────────── -->
        <ng-container *ngIf="view === 'detail'">
            <div class="detail-row">
                <span class="detail-row__label">{{ 'aumico_partner_connect_modal_status_label' | i18next }}</span>
                <span>
                    <span
                        class="status-chip"
                        [class.status-chip--connected]="connection.connected"
                        [attr.data-testid]="
                            'partner-connect-state-' + (connection.connected ? 'connected' : 'disconnected')
                        "
                    >
                        {{
                            (connection.connected
                                ? 'aumico_partner_connect_status_connected'
                                : 'aumico_partner_connect_status_not_connected'
                            ) | i18next
                        }}
                    </span>
                </span>
            </div>

            <div class="modal-text">
                {{ modalTextKey | i18next: { partner: connection.displayName } }}
            </div>

            <div class="detail-row">
                <span class="detail-row__label">{{ 'aumico_outbound_api_scopes_label_long' | i18next }}</span>
                <ul class="scope-list" data-testid="partner-connect-scopes">
                    <li *ngFor="let labelKey of scopeLabelKeys">{{ labelKey | i18next }}</li>
                </ul>
            </div>

            <div class="error-text" *ngIf="hasError" data-testid="partner-connect-error">
                {{ 'aumico_outbound_api_error_generic' | i18next }}
            </div>

            <div class="footer">
                <ham-button
                    *ngIf="!connection.connected && connection.startUrl != null"
                    data-testid="partner-connect-button"
                    (buttonClick)="onConnect()"
                    >{{ 'aumico_partner_connect_connect_button' | i18next: { partner: connection.displayName } }}</ham-button
                >
                <ham-button
                    *ngIf="connection.connected"
                    variant="red"
                    data-testid="partner-disconnect-button"
                    (buttonClick)="onDisconnectRequested()"
                    >{{ 'aumico_partner_connect_disconnect_button' | i18next }}</ham-button
                >
            </div>
        </ng-container>

        <!-- ─────────── Disconnect confirmation ─────────── -->
        <ng-container *ngIf="view === 'confirm_disconnect'">
            <div class="disconnect-warning" data-testid="partner-disconnect-warning">
                {{ 'aumico_partner_connect_disconnect_confirm_text' | i18next }}
            </div>
            <div class="error-text" *ngIf="hasError">{{ 'aumico_outbound_api_error_generic' | i18next }}</div>
            <div class="footer">
                <ham-button variant="gray" data-testid="partner-disconnect-cancel" (buttonClick)="onBackToDetail()">{{
                    'aumico_button_cancel' | i18next
                }}</ham-button>
                <ham-button
                    variant="red"
                    data-testid="partner-disconnect-confirm"
                    [disabled]="busy"
                    (buttonClick)="onDisconnectConfirmed()"
                    >{{ 'aumico_partner_connect_disconnect_confirm_button' | i18next }}</ham-button
                >
            </div>
        </ng-container>
    </div>
</ham-modal>
